// Libs
import React from 'react'
import PropTypes from 'prop-types'
import _size from 'lodash/size'

import {
  record as recordPropType,
  maybeFunction,
} from './propTypes'

// Styles
import {
  rowStyle,
  dataRowStyle,
} from './styles'
import classes from './styles.scss'

// Local
function getStyle ({style, record, selected, odd}) {
  if (typeof style === 'function') {
    return {
      ...rowStyle,
      ...style({record, selected, odd}),
    }
  } else if (style && typeof style === 'object' && _size(style)) {
    return {
      ...rowStyle,
      ...style,
    }
  }

  return rowStyle
}
// Components
import SelectionCheckbox from './SelectionCheckbox'

export const TableRow = ({record, children, odd, onSelect, selected, smallScreen, style}) => {
  const renderCheckbox = function () {
    if (record.prop_hide_checkbox) {
      return <div style={{
        width: '30px',
      }} />
    }
    return (
      <SelectionCheckbox
        record={record}
        onSelect={!smallScreen && onSelect}
        selected={!!selected}
      />
    )
  }
  return (
    <div
      data-test='TableRow'
      style={getStyle({style, record, selected, odd})}
      className={
        `${classes[smallScreen ? 'table-row-mobile' : 'table-row']}` +
        ` ${odd ? classes['odd'] : ''} ${selected ? classes['selected'] : ''}`
      }
      onClick={record.prop_hide_checkbox ? null : onSelect}
      >
      {renderCheckbox()}
      <div style={dataRowStyle}>{children}</div>
    </div>
  )
}

TableRow.propTypes = {
  record: recordPropType,
  children: PropTypes.node,
  odd: PropTypes.bool.isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: maybeFunction,
  smallScreen: PropTypes.bool,
  style: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
}

export default TableRow
